export const serverScheme = "https";
export const serverUrl = 'api.nickcleveland.com';
// export const serverScheme = "http";
// export const serverUrl = 'localhost:8080';

export const serverPort = null;
export const serverHttpLinkString = `${serverScheme}://${serverUrl}`;
export const twitchAuthLink = `${serverScheme}://${serverUrl}/auth/twitch`;
export const discordAuthLink = `${serverScheme}://${serverUrl}/auth/discord`;
export const websiteName = `NickCleveland`;
export const kickUsername = `nickcleveland`;
export const twitterLink = `nickcleveland`;
export const instaLink = `nickcleveland`;
export const discordLink = `nickcleveland`;
export const kickLink = `nickcleveland`;
export const youtubeLink = `nickcleveland`;

